import cx from 'classnames';
import React from 'react';

import { useNavigation } from '../Navigation.context';
import SubnavBackButton from './SubnavBackButton';
import * as Styles from './Subnavigation.module.scss';
import TemplateA from './Templates/TemplateA';
import TemplateB from './Templates/TemplateB';

interface SubnavigationProps {}

const Subnavigation: React.FC<SubnavigationProps> = () => {
  const { secondary } = useNavigation();

  if (!secondary.active) {
    return null;
  }

  return (
    <div
      className={cx(Styles.Subnavigation, {
        [Styles.SubnavigationVisible]: secondary.active,
      })}
    >
      <SubnavBackButton onClick={secondary.close} label="Back to Main Menu" />
      {secondary.template === 'A' && (
        <TemplateA
          sections={secondary.sections}
          features={secondary.features}
        />
      )}
      {secondary.template === 'B' && (
        <TemplateB sections={secondary.sections} />
      )}
    </div>
  );
};

export default Subnavigation;
